import { createContext, useContext } from 'react';

type Callback = () => void;

export const ClearTransactionsListCacheContext = createContext<Callback>(() => {});

export const useClearTransactionsCacheIfNeeded = (): Callback =>
    useContext(ClearTransactionsListCacheContext);
